const citiesData = [
  {
      "city": "Johannesburg",
      "country": "South Africa",
      "millionaires": 12300,
      "centiMillionaires": 25,
      "billionaires": 2,
      "wealthGrowth": -44
  },
  {
      "city": "Cape Town",
      "country": "South Africa",
      "millionaires": 7400,
      "centiMillionaires": 28,
      "billionaires": 1,
      "wealthGrowth": 20
  },
  {
      "city": "Cairo",
      "country": "Egypt",
      "millionaires": 7200,
      "centiMillionaires": 30,
      "billionaires": 4,
      "wealthGrowth": -21
  },
  {
      "city": "Nairobi",
      "country": "Kenya",
      "millionaires": 4400,
      "centiMillionaires": 10,
      "billionaires": "",
      "wealthGrowth": 25
  },
  {
      "city": "Lagos",
      "country": "Nigeria",
      "millionaires": 4200,
      "centiMillionaires": 12,
      "billionaires": 2,
      "wealthGrowth": -48
  },
  {
      "city": "Cape Winelands (region)",
      "country": "South Africa",
      "millionaires": 3600,
      "centiMillionaires": 16,
      "billionaires": 2,
      "wealthGrowth": 28
  },
  {
      "city": "Durban, Umhlanga & Ballito",
      "country": "South Africa",
      "millionaires": 3500,
      "centiMillionaires": 11,
      "billionaires": "",
      "wealthGrowth": -10
  },
  {
      "city": "The Garden Route (region)",
      "country": "South Africa",
      "millionaires": 3200,
      "centiMillionaires": 5,
      "billionaires": "",
      "wealthGrowth": 32
  },
  {
      "city": "Casablanca",
      "country": "Morocco",
      "millionaires": 2800,
      "centiMillionaires": 10,
      "billionaires": 1,
      "wealthGrowth": 24
  },
  {
      "city": "Pretoria",
      "country": "South Africa",
      "millionaires": 2100,
      "centiMillionaires": 2,
      "billionaires": "",
      "wealthGrowth": -30
  },
  {
      "city": "Accra",
      "country": "Ghana",
      "millionaires": 1900,
      "centiMillionaires": 4,
      "billionaires": "",
      "wealthGrowth": 25
  },
  {
      "city": "Luanda",
      "country": "Angola",
      "millionaires": 1500,
      "centiMillionaires": 3,
      "billionaires": "",
      "wealthGrowth": -33
  },
  {
      "city": "Marrakech",
      "country": "Morocco",
      "millionaires": 1400,
      "centiMillionaires": 12,
      "billionaires": 2,
      "wealthGrowth": 65
  },
  {
      "city": "The Whale Coast (region)",
      "country": "South Africa",
      "millionaires": 1200,
      "centiMillionaires": 5,
      "billionaires": "",
      "wealthGrowth": 35
  },
  {
      "city": "Windhoek",
      "country": "Namibia",
      "millionaires": 1200,
      "centiMillionaires": 2,
      "billionaires": "",
      "wealthGrowth": 30
  },
  {
      "city": "Dar Es Salaam",
      "country": "Tanzania",
      "millionaires": 1200,
      "centiMillionaires": 4,
      "billionaires": 1,
      "wealthGrowth": 18
  },
  {
      "city": "Tangier",
      "country": "Morocco",
      "millionaires": 1000,
      "centiMillionaires": 6,
      "billionaires": 1,
      "wealthGrowth": 42
  },
  {
      "city": "Algiers",
      "country": "Algeria",
      "millionaires": 1000,
      "centiMillionaires": 4,
      "billionaires": "",
      "wealthGrowth": -26
  },
  {
      "city": "Grand Baie",
      "country": "Mauritius",
      "millionaires": 900,
      "centiMillionaires": 5,
      "billionaires": "",
      "wealthGrowth": 95
  },
  {
      "city": "Kigali",
      "country": "Rwanda",
      "millionaires": 800,
      "centiMillionaires": 3,
      "billionaires": "",
      "wealthGrowth": 88
  }
];

// const totalData = [
//     {
//         "country": "Total BRICS",
//         "millionaires": 1582000,
//         "centiMillionaires": 4716,
//         "billionaires": 549,
//         "wealthGrowth": 54,
//     }
// ];

// export {countriesData, totalData};
export {citiesData};